import { render, staticRenderFns } from "./RequestedLinks.vue?vue&type=template&id=53dc65f1&scoped=true"
import script from "./RequestedLinks.vue?vue&type=script&lang=js"
export * from "./RequestedLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dc65f1",
  null
  
)

export default component.exports